/* eslint-disable */

import * as d3 from 'd3'
import { CrainD3Vis } from './CrainD3Vis';
import { escapeHtml } from '@/components/Explore/Visualizations/shared/utilities';
import ColorRange from '@/helpers/ColorRange';
import store from '@/store/store'
import _ from "lodash";

class LineChartControl extends CrainD3Vis {
  constructor(svg, cd, svgDiv) {
    super(svg, cd, svgDiv);
    this.selectClass = 'dot';
    this.xScale = undefined;
    this.yScale = undefined;
    this.config = {
      color: 'Size',
      metric: 'size',
    };
  }

  update(reset = false, cType = null) {
    //d3.select('#svgDiv svg').selectAll('*').remove();
    this.svg.selectAll('*').remove();

    const margin = {
      top: 50,
      right: 50,
      bottom: 50,
      bottomWithLabels: 50,
      left: 50,
    };
    const width = document.getElementById(this.svgDiv.split(" ")[0].slice(1)).clientWidth - margin.left - margin.right;
    const height = document.getElementById(this.svgDiv.split(" ")[0].slice(1)).clientHeight - margin.top - margin.bottomWithLabels;

    const self = this;

    const dataset = d3.range(this.crainData.xLayers.length).map(function (x) {
      const processed = Object.values(self.crainData.processedData).find(p => p.x === x);
      return {
        x: x,
        y: processed.filtdata? processed.filtdata.size:processed.data.size
      };
    })

    const numberOfPoints = this.crainData.xLayers.length;
    const minSize = _.minBy(dataset, "y").y;
    const maxSize = _.maxBy(dataset, "y").y;
    const xScale = d3.scaleLinear()
      .domain([0, numberOfPoints-1])
      .range([0, width]);

    let min = minSize;
    let max = maxSize;
    if (self.config.color === 'recency') {
      min = -3;
      max = 3;
    }
    const colorRange = new ColorRange(self.config.color, min, max);

    const yScale = d3.scaleLinear()
      .domain([0, maxSize])
      .range([height, 0]);

    const line = d3.line()
      .x((d, i) => xScale(i))
      .y((d) => yScale(d.y))

    //const svg = d3.select('#svgDiv svg')
    const svg = this.svg
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('id', 'main')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    svg.append('g')
      .attr('transform', 'translate(0,' + height + ')')
      .call(
        d3.axisBottom(xScale)
          .scale(xScale)
          .tickFormat(n => self.crainData.xLayers[n] ? self.crainData.xLayers[n][0].name : null)
      );

    svg.append('g')
      .call(
        d3.axisLeft(yScale)
          .tickFormat(function(e){
            // Only show integer labels on Y-axis, hide floats
            if (Math.floor(e) !== e) {
              return;
            }
            return e;
          })
      );

    svg.append("linearGradient")
      .attr("id", "recency-gradient")
      .attr("gradientUnits", "userSpaceOnUse")
      .attr("x1", xScale(0))
      .attr("x2", xScale(self.crainData.xLayers.length))
      .attr("y1", 0)
      .attr("y2", 0)
      .selectAll("stop")
      .data(function() {
        let data = [];
        for (let i = 0; i < self.crainData.xLayers.length; i++) {
          const processed = Object.values(self.crainData.processedData).find(p => p.x === i).filtdata? Object.values(self.crainData.processedData).find(p => p.x === i).filtdata:Object.values(self.crainData.processedData).find(p => p.x === i).data
          let point = processed[self.config.color];
          if (self.config.color === 'recency') {
            if (point === "-infinity" || point < -3) {
              point = -3;
            }
            if (point === "infinity" || point > 3) {
              point = 3;
            }
          }
          const colors = colorRange.getColors(point)
          let position = 100 / self.crainData.xLayers.length * i;
          position = Math.round(position * 100) / 100;
          data.push({offset: `${position}%`, color: colors.bgColor});
        }
        return data;
      })
      .enter()
      .append("stop")
      .attr("offset", d => d.offset)
      .attr("stop-color", d => d.color);

    svg.append('path')
      .datum(dataset)
      .attr('d', line)
      .attr('fill', 'none')
      .attr('stroke', 'url(#recency-gradient)')
      .attr('stroke-width', 3);

    svg.append('path')
      .datum(dataset)
      .attr('d', line)
      .attr('fill', 'none')
      .attr('stroke', 'rgba(0, 0, 0, .3)')
      .attr('stroke-width', 1);

    svg.selectAll('.dot')
      .data(function(d,x) {
        let data = [];
        for (let i = 0; i < self.crainData.xLayers.length; i++) {
          const processed = Object.values(self.crainData.processedData).find(p => p.x === i);
          data.push({
            ...processed,
            x: processed.x,
            y: processed.filtdata? processed.filtdata.size:processed.data.size,
          });
        }
        //console.log('data',data);
        return data;
      })
      .enter()
      .append('g')
      .attr('class', 'dot')
      .append('circle')
      .attr('fill', function(pos, x) {
        const processed = Object.values(self.crainData.processedData).find(p => p.x === x).filtdata? Object.values(self.crainData.processedData).find(p => p.x === x).filtdata:Object.values(self.crainData.processedData).find(p => p.x === x).data;
        let point = processed[self.config.color];
        if (self.config.color === 'recency') {
          if (point === "-infinity" || point < -3) {
            point = -3;
          }
          if (point === "infinity" || point > 3) {
            point = 3;
          }
        }
        const colors = colorRange.getColors(point);
        return colors.bgColor;
      })
      .attr('stroke', '#000')
      .attr('stroke-width', 2)
      .attr('cx', (d, i) => xScale(i))
      .attr('cy', d => yScale(d.y))
      .attr('r', 5)
      .on('mouseover', function (pos, x) {
        const processed = Object.values(self.crainData.processedData).find(p => p.x === x).filtdata? Object.values(self.crainData.processedData).find(p => p.x === x).filtdata:Object.values(self.crainData.processedData).find(p => p.x === x).data
        let recency = processed.recency;
        if (recency === "-infinity" || recency < -3) {
          recency = -3;
        }
        if (recency === "infinity" || recency > 3) {
          recency = 3;
        }
        d3.select('#hoverDiv')
          .style('opacity', 0.9)
          .style('top', event.clientY + 10 + 'px')
          .style('left', event.clientX + 10 + 'px')
          .html(`
            <strong>${escapeHtml(self.crainData.xLayers[x][0].name)}</strong><br/>
            Size: ${processed.size}<br/>
            <!-- Original size: ${processed.origsize}<br/> -->
            Recency: ${recency}
          `);
      })
      .on('mouseout', function (pos, x) {
        d3.select('#hoverDiv')
          .style('opacity', 0);
      });

    svg.append("text")
      .attr("text-anchor", "end")
      .attr("x", width / 2)
      .attr("y", height + 40)
      .attr('font-weight', 'bold')
      .text("Year");

    svg.append("text")
      .data(function(d,x) {
        let data = [];
        for (let i = 0; i < self.crainData.xLayers.length; i++) {
          const processed = Object.values(self.crainData.processedData).find(p => p.x === i);
          data.push({
            ...processed,
            filter: processed.filtdata? true:false,
          });
        }
        return data;
      })
      .attr("text-anchor", "end")
      .attr("x", 30)
      .attr("y", -20)
      .attr('font-weight', 'bold')
      .text(d => d.filter? "Size (Filter)":"Size");

    this.controlSelect();

    //setTimeout(() => {
    //  store.dispatch('loadAnimEnd');
      store.dispatch('saveLoadingStep', "");
    //}, 6000);
  }

  /**
   * Perform formatting when in selection modus
   * @param selection: d3 selection of groups contraining rects
   */
  controlSelectFormatting(selection) {
    //console.log('controlSelectFormatting');
    //console.log('controlSelectFormatting selected', this.crainData.selected);
    //console.log('controlSelectFormatting selected size', this.crainData.selected.size);

    if (this.crainData.selected.size > 0) {
      selection
        .select('rect')
        .attr('fill',
          d => d.selected
            ? this.dataInterpolator(this.dataScale((this.config.normOverX ? 1 + d[this.dataLoc][this.dataLabel] / this.crainData.dataNormX[d.y] : d[this.dataLoc][this.dataLabel])))
            : 'lightgray'
        )
    } else {
      selection.call(this.controlNormalFormatting)
    }
  }
}

export { LineChartControl }
